export default {
  currentPeriod: (state) => state.currentPeriod,
  referencePeriod: (state) => state.referencePeriod,
  minAnalyticPeriod: (state) =>
    state.allConfigurationPeriods?.length ? state.allConfigurationPeriods[state.allConfigurationPeriods.length - 1].finalDate : '',
  maxAnalyticPeriod: (state) => (state.allConfigurationPeriods?.length ? state.allConfigurationPeriods[0].finalDate : ''),
  analyticAllPeriods: (state) => state.allConfigurationPeriods,
  analyticsConfiguration: (state) => state.configuration,
  referenceClientsMetrics: (state) => state.clientsMetrics.reference,
  currentClientsMetrics: (state) => state.clientsMetrics.current,
  periodMigrations: (state) => state.periodMigrations,
  rfvAnalyticConfigurations: (state) => state.rfvAnalyticConfigurations,
  loadingAnalyticConfigurations: (state) => state.loadingAnalyticConfigurations,
}
